import { AccountConnectorService } from '../configuration';
import { open as openPopup } from '../popup';
import request, { endpoint } from './request';

export function authConnector(
  service: AccountConnectorService,
  successCallback: (data: any) => void,
  errorCallback: (data: any) => void,
) {
  openPopup(`${endpoint}/auth/${service}`);

  const onMessageFunc = (event: MessageEvent) => {
    if (event.data.type === 'clearbitAuthComplete' && successCallback) {
      successCallback(event.data);
    } else if (event.data.type === 'clearbitAuthError' && errorCallback) {
      errorCallback(event.data);
    }

    window.removeEventListener('message', onMessageFunc, false);
  };

  window.onmessage = onMessageFunc;
}

export function getCurrentUser() {
  return request({
    path: '/v1/users/current',
  });
}

export function getCurrentAccount() {
  return request({
    path: '/v1/accounts/current',
  });
}

export function isAuthRoute() {
  return window.location.pathname.startsWith('/auth/');
}

export type AuthErrorResponse = {
  type: 'auth';
  subtype?: 'mfa_required' | 'mfa_setup_required';
};

export function authUser(error: AuthErrorResponse) {
  if (isAuthRoute()) return;

  if (error.subtype === 'mfa_required') {
    window.location.pathname = '/auth/mfa';
    return;
  } else if (error.subtype === 'mfa_setup_required') {
    window.location.assign(
      `${window.location.origin}/auth?mfa_setup_required=true`,
    );
    return;
  }

  if (window.localStorage.getItem('USE_STYTCH_AUTH') === 'true') {
    window.location.pathname = '/auth/login';
    return;
  }

  window.location.pathname = '/auth';
}

export function logoutUser() {
  window.location.pathname = '/logout';
}
